module.exports = __webpack_public_path__ + "static/media/bootstrap.d057835e.png";